import {Injectable} from "@angular/core";

import {ApiUrls} from "@app/core/shared/infrastructure/api-urls";
import {EuropastryBaseHandler} from "@app/core/shared/infrastructure/base.handler/europastry-base.handler";
import {HandlerBuilder, HttpMethod} from "@app/core/shared/infrastructure/base.handler/base-handle.parameters";
import {Credentials} from "@app/core/credentials/domain/credentials";

@Injectable({
  providedIn: "root",
})

export class LoginHandler {
  constructor(
      private baseHandler: EuropastryBaseHandler,
      private apiUrls: ApiUrls,
  ) { }

  public execute(credentials: Credentials, recaptchaToken?: string): any {
    const parameters = new HandlerBuilder()
      .method(HttpMethod.post)
      .url(this.apiUrls.LOGIN)
        .body(recaptchaToken ? {recaptchaToken} : {})
      .authorization(credentials)
      .build()

    return this.baseHandler.execute(parameters);
  }
}
